import { get, chain, map } from "lodash"
import { aggregateFactorsSumBy } from "helpers/factorClassification/index"
import { mapPerformanceAttributionFactorReturnsToValues } from "helpers/contributors"

export function mapAggregatedFactors(performanceAttributionDates, mustAggregateFactors, factorsClassification) {
  const adjustedDates = mapPerformanceAttributionFactorReturnsToValues(performanceAttributionDates, "cumulativePercent")

  return map(adjustedDates, date => {
    let factors = get(date, "attribution.factors")

    const adjustedDate = {
      ...date,
      attribution: {
        ...get(date, "attribution"),
        summary: {
          factors: get(date, "attribution.summary.factors.cumulativePercent"),
          specific: get(date, "attribution.summary.specific.cumulativePercent"),
          trading: get(date, "attribution.summary.trading.cumulativePercent"),
        },
      },
      total: get(date, "totalReturn.cumulativePercent"),
    }

    if (!factors || !mustAggregateFactors) {
      return adjustedDate
    }

    factors = aggregateFactorsSumBy(factorsClassification, factors, "value")
    return chain(adjustedDate)
      .cloneDeep()
      .set("attribution.factors", factors)
      .value()
  })
}
